module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACWSURBVHgB7ZUBCoAgDEU/0UG8ad2gbmg3sBtUSlItRZciUj34lM1tbYoCldBtUpsWIv1tQAYGR3CqHonYCoTDJnBUlIT926d2Q3N6l7i3ggaLtUtfkqJEtYDjV6SSqpJIXBeTjtm4euvbTSE/w/fW5E9iaCPnTYExm/ccK/P+FIhHEN8gPcJXrk8jGOjJihFcIcNdn8QKXrtbBjIfYiAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/trash-2.png
// module id = /2wi
// module chunks = 1